export default class ProofPlayService {

  constructor($http,
              $q,
              $window,
              SessionsService,
              StorageService,
              $stateParams,
              $state,
              ToastsService) {
    'ngInject';
    this.$http = $http
    this.$q = $q
    this.$window = $window
    this.SessionsService = SessionsService
    this.$stateParams = $stateParams
    this.StorageService = StorageService
    this.$state = $state
    this.ToastsService = ToastsService
    this.makeHTTPRequest = this.makeHTTPRequest.bind(this);
    this.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    if (this.origin === "http://localhost:3000") {
      this.origin = "http://localhost:8080"
    }
    this.uriBase = 'proofplay/api/v1';
  }

  makeHTTPURL(where_to_go, tenant) {
    const idToken = this.StorageService.get('idToken');  // TODO: use SessionsService.
    return `${process.env.__backendUrl__}/proofplay/api/v1` + where_to_go + tenant + '?JWT=' + idToken;
  }

  makeHTTPRequest(where_to_go, tenant) {
    let deferred = this.$q.defer();
    let url = this.makeHTTPURL(where_to_go, tenant);
    return this.$http.get(url);
  }

  getAllResources(tenant) {
    let r = this.makeHTTPRequest("/retrieve_all_resources/", tenant);
    // the catch is only done here because 3 proof of play views are initilized at the same time
    // so this catch will be done 3 times with 3 error messages if we add it to getAllDisplays and getAllLocations
    r.catch((err, data) => {
      let {status} = err;
      if (status === 403) {
        this.ToastsService.showErrorToast("You are not allowed to view this tenant!");
        this.$state.go('main.proof', {});
      }
      if (status === 404) {
        this.ToastsService.showErrorToast("You must select a tenant first!");
        return this.$state.go('main.proof', {});
      }
    });

    return r.then(data => data);
  }


  getAllDisplays(tenant) {
    return this.makeHTTPRequest("/retrieve_all_displays/", tenant);
  }


  getAllLocations(tenant) {
    return this.makeHTTPRequest("/retrieve_all_locations/", tenant);
  }


  getAllTenants() {
    return this.makeHTTPRequest("/retrieve_my_tenants", '');
  }

  /** @access private */
  getUrl(reportType, startDate, endDate, items, tenant) {
    // Note: the old version of this code had an extra `|` prefix; keeping this behavior for compatibility.
    const idToken = this.StorageService.get('idToken');  // TODO: use SessionsService.
    const joinedItems = '|' + items.join('|');
    return [
      this.origin,
      this.uriBase,
      reportType,
      startDate,
      endDate,
      joinedItems,
      tenant,
    ].join('/') + `?JWT=${idToken}`;
  }

  downloadCSVForMultipleResourcesByDate(startDate, endDate, resources, tenant) {
    const url = this.getUrl('multi_resource_by_date', startDate, endDate, resources, tenant);
    this.$window.open(url, '_blank');
  }

  downloadCSVForMultipleResourcesByDevice(startDate, endDate, resources, tenant) {
    const url = this.getUrl('multi_resource_by_device', startDate, endDate, resources, tenant);
    this.$window.open(url, '_blank');
  }

  downloadCSVForMultipleDevicesSummarized(startDate, endDate, devices, tenant) {
    const url = this.getUrl('multi_device_summarized', startDate, endDate, devices, tenant);
    this.$window.open(url, '_blank');
  }

  downloadCSVForMultipleDevicesByDate(startDate, endDate, devices, tenant) {
    const url = this.getUrl('multi_device_by_date', startDate, endDate, devices, tenant);
    this.$window.open(url, '_blank');
  }

  downloadCSVForMultipleLocationsByDevice(startDate, endDate, locations, tenant) {
    const url = this.getUrl('multi_location_by_device', startDate, endDate, locations, tenant);
    this.$window.open(url, '_blank');
  }

  downloadCSVForMultipleLocationsSummarized(startDate, endDate, locations, tenant) {
    const url = this.getUrl('multi_location_summarized', startDate, endDate, locations, tenant);
    this.$window.open(url, '_blank');
  }

  /** @access private */
  createFilterFor(query) {
    query = angular.lowercase(query);
    return function (resource) {
      resource = angular.lowercase(resource);
      return (resource.indexOf(query) === 0);
    };
  }

  querySearch(resources, searchText) {
    if (searchText) {
      return resources.filter(this.createFilterFor(searchText));
    } else {
      return resources;
    }
  }
}
